import Vue from 'vue'
import {IDestroyable} from '~/interfaces/modelInterfaces'

export default abstract class BaseModel implements IDestroyable {
  static get displayName(): string {
    throw new Error(`Display name for ${this.name} not implemented`);
  }

  get displayName(): string {
    return (<any>this.constructor).displayName;
  }

  /**
   * Initial usage is to generalize specific model implementations of displayName into a common one usable by the can system
   * Specific can is ObjectModelProperties has a dynamic getter for displayName but need something static for can system
   */
  get generalClassDisplayName(): string {
    return (<any>this.constructor).displayName
  }

  destroy(): void {
    this.markForDestruction()
  }

  _markedForDestruction: boolean
  get markedForDestruction(): boolean {
    return this._markedForDestruction
  }

  set markedForDestruction(val: boolean) {
    // just can't get this to be reactive without +Vue.set+
    // issue: ProcessFlow builder step config panel kept step displaying after ProcessFlowStep.destroy was called
    Vue.set(this, '_markedForDestruction', val)
  }

  markForDestruction(): void {
    this.markedForDestruction = true
  }

  unmarkForDestruction(): void {
    this.markedForDestruction = false
  }
}